module.exports = __webpack_public_path__ + "static/media/Gina Edmunds Headshot_1700055954119.f555eb72.jpeg";